module.exports = __webpack_public_path__ + "static/media/feedbackReceived.e7319c94.svg";